import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { AccelaControl } from 'src/app/modules/shared/model/accelaControl.model';
import { AdminSelectionEvent } from '../../model/adminSelectionEvent';

@Component({
  selector: 'accela-checkbox-input',
  templateUrl: './accela-checkbox-input.component.html',
  styleUrls: ['./accela-checkbox-input.component.css']
})
export class AccelaCheckboxInputComponent implements OnInit, AfterViewInit {
  @Input() controlRef: AbstractControl;
  @Input() parentFormRef: UntypedFormGroup;
  @Input() adminMode = false;
  @Input() readonlyMode = false;
  @Input() requiredValidationMsg: string;
  @Output() selectionEvent = new EventEmitter<AdminSelectionEvent>();
  @ViewChild('accelaControlDiv') accelaControlDiv: ElementRef;
  @Output() oncbChange = new EventEmitter<boolean>();
  label: string;

  controlData: AccelaControl;

  Value: boolean;

  ngOnInit(): void {
    this.controlData = this.controlRef.controlData;
    this.label = this.controlData.label;
  }

  ngAfterViewInit(): void {
    if(this.adminMode){
      this.controlData.readOnly = true;
      this.accelaControlDiv.nativeElement.addEventListener('click', (e: MouseEvent) =>{
        this.adminSelect(e);
      });
    }
  }

  getDivElementId(): string{
    return 'div_'+this.controlData.name;
  }

  getRequiredFieldValidationMsg(): string{
    return this.requiredValidationMsg + ' '+this.label;
  }

  adminSelect(e: Event): void {
    const ev = e as AdminSelectionEvent;
    ev.controlData = this.controlData;
    ev.elementRef = e.target as Element;
    this.selectionEvent.emit(ev);
   }
 
  handleInputChange(event) {    
    this.oncbChange.emit(event.checked);
  }
}
